import apiClient from '@/api/client';
import type {
  RecentErrorsResponse,
  StatsSummary,
  TopRoutesResponse,
  UsageHistogram,
} from '@/types/stats';

export async function fetchStatsSummary(): Promise<StatsSummary> {
  const response = await apiClient.get<StatsSummary>('/api/v1/stats/summary');
  return response.data;
}

export async function fetchUsageHistogram(days = 7): Promise<UsageHistogram> {
  const response = await apiClient.get<UsageHistogram>(
    '/api/v1/stats/usage-histogram',
    { params: { days } },
  );
  return response.data;
}

export async function fetchTopRoutes(
  limit = 10,
  days = 7,
): Promise<TopRoutesResponse> {
  const response = await apiClient.get<TopRoutesResponse>(
    '/api/v1/stats/top-routes',
    { params: { limit, days } },
  );
  return response.data;
}

export async function fetchRecentErrors(limit = 20): Promise<RecentErrorsResponse> {
  const response = await apiClient.get<RecentErrorsResponse>(
    '/api/v1/stats/recent-errors',
    { params: { limit } },
  );
  return response.data;
}

